import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import Detail from './Detail';

const IntervalPasswordReset = props => {
  return (
    <Switch>
      <Route render={routerProps => <Detail {...props} {...routerProps} />} />
    </Switch>
  );
};

export default withRouter(IntervalPasswordReset);
